import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ParallaxSection from "../../common/components/ParallaxSection";
import SectionWines from "../../common/components/SectionWines";

export default function Wines() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { t } = useTranslation();
  return (
    <>
      <Helmet htmlAttributes={{ lang: t("language") === "esp" ? "es" : "en" }}>
        <title>Mascota Vineyards - Wines</title>
        <meta name="description" content={t("our-wines.text")} />
        <link rel="canonical" href="https://mascotavineyards.com/wines" />
      </Helmet>
      <ParallaxSection
        urlBackgroundImgDesktop={require(`../../assets/images/section_wines/banner-our-wines.jpg`)}
        urlBackgroundImgMobile={require(`../../assets/images/section_wines/banner-our-wines-mobile.jpg`)}
        contentAling="flex-end"
        imageAlign="right"
      />
      <SectionWines />
    </>
  );
}
